import React from "react";

import { graphql } from "gatsby";

import {
  Container,
  Content,
  VideoContainer,
  VideoContainerProps,
  YoutubeIframe,
  YoutubeIframeProps,
} from "./YoutubeBlock.styles";

export interface YoutubeBlockProps extends Queries.SanityYoutubeBlock {}

const YoutubeBlock: React.FC<YoutubeBlockProps> = ({
  variant = "light-mode",
  videoURL,
  videoAlt,
}) => (
  <Container>
    <Content>
      {videoURL && videoAlt && (
        <VideoContainer
          $variant={variant as VideoContainerProps["$variant"]}
          $videoW={1220}
          $videoH={686}
        >
          <YoutubeIframe
            $variant={variant as YoutubeIframeProps["$variant"]}
            width={1220}
            height={686}
            src={videoURL}
            title={videoAlt}
            $allowfullscreen
          />
        </VideoContainer>
      )}
    </Content>
  </Container>
);

export const query = graphql`
  fragment YoutubeBlock on SanityYoutubeBlock {
    _key
    _type
    variant
    videoURL
    videoAlt
  }
`;

export default YoutubeBlock;
